import { PropsWithChildren, useMemo, useState } from 'react'
import GrundDialogContext from '../contexts/GrundDialogContext'
import useDialog from '../components/Dialog/useDialog'
import GrundDialog, { GrundDialogData } from '../components/Befehle/GrundDialog'

export default function GrundDialogProvider({
  children
}: Readonly<PropsWithChildren>) {
  const [grundDialogState, openGrundDialog, closeGrundDialog, grundDialogData] =
    useDialog<GrundDialogData>()

  const [submittedGruende, setSubmittedGruende] = useState<
    Record<string, string>
  >({})

  const value = useMemo(
    () => ({
      openGrundDialog: (dialogData: GrundDialogData) => {
        openGrundDialog(dialogData)
      },
      submittedGruende,
      resetGruende: (fieldName: string) => {
        setSubmittedGruende((currentGruende) => ({
          ...currentGruende,
          [fieldName]: ''
        }))
      }
    }),
    [openGrundDialog, submittedGruende]
  )

  return (
    <GrundDialogContext.Provider value={value}>
      <GrundDialog
        dialogState={grundDialogState}
        dialogData={grundDialogData}
        onSubmit={(gruende, fieldName) => {
          setSubmittedGruende((currentGruende) => ({
            ...currentGruende,
            [fieldName]: gruende
          }))
        }}
        closeDialog={closeGrundDialog}
        data-testid="grund-dialog"
      />
      {children}
    </GrundDialogContext.Provider>
  )
}
